import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {CandidatureFormation} from '../candidature-formation.model';
import {Response} from '@angular/http';
import {CONSTANTS} from '../../../cadens.constants';
import {ParametrageService} from '../../parametrage';
import {PieceJointe, PieceJointeService} from '../../piece-jointe';
import {FormationService, Piece, PieceService, QuestionService} from '../../formation';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AlertService} from 'ng-jhipster';
import {Referent, ReferentService} from '../../referent';
import {Observable} from 'rxjs';
import {Reponse, ReponseService} from '..';
import {DomSanitizer} from '@angular/platform-browser';
import {TranslateService} from 'ng2-translate';
import {CandidatureFormationService} from '../candidature-formation.service';
import {ExportService, IKeyedCollection, JhiAlertComponent, KeyedCollection} from '../../../shared';

@Component({
    selector: 'jhi-pieces-component',
    templateUrl: './pieces.component.html'
})
export class PiecesComponent implements OnInit, OnChanges {

    @Input() candidatureFormation: CandidatureFormation = {};
    @Input() candidatureFormationId: Number = null;
    @Input() candidatureFormationFc: Boolean = null;
    @Input() isEditable: Boolean;
    @Input() missingPieces: Boolean;
    @Input() missingReferent: Boolean;
    @Output() missingPiecesChange: EventEmitter<Boolean> = new EventEmitter();
    @Input() isBO: number; // 0=candidat ; 1=BO lecture seule; 2=BO Modifiable
    piecesJointes: PieceJointe[] = [];
    parametrage: any;
    maxSize = 2000000;
    pieces: Piece[] = [];
    otherUploadedFiles: any[] = [];
    lastIdx: number;
    uploadedFiles: IKeyedCollection<any> = new KeyedCollection<any>();
    aide: Piece;
    constantes;
    @Input() currentLang: string;
    radios: any[] = [];
    alertId: number;
    @Input() isSaving: Boolean;
    @Input() referents: Referent[] = [];
    @Output() referentsChange: EventEmitter<Referent[]> = new EventEmitter();
    lettreRecommandation: Piece;
    private modalRef: NgbModalRef;
    private isReloading = false;
    private ngInitDone = false;

    private loadReferentSubscription: any;
    @Input() loadReferentEvents: Observable<void>;

    private static getCookie(name) {
        let value = '; ' + document.cookie;
        let parts = value.split('; ' + name + '=');
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
    }

    constructor(private parametrageService: ParametrageService,
                private translate: TranslateService,
                private sanitizer: DomSanitizer,
                private pieceService: PieceService,
                private formationService: FormationService,
                private pieceJointeService: PieceJointeService,
                private referentService: ReferentService,
                private reponseService: ReponseService,
                private alertService: AlertService,
                private questionService: QuestionService,
                private modalService: NgbModal,
                private candidatureFormationService: CandidatureFormationService,
                private exportService: ExportService) {
        this.constantes = CONSTANTS;
    }

    ngOnChanges(changes: any) {
        if (((changes['candidatureFormation'] != null
                && changes['candidatureFormation'].previousValue.id != null
                && changes['candidatureFormation'].previousValue.id !== changes['candidatureFormation'].currentValue.id) ||
                (changes['candidatureFormationId'] != null
                    && changes['candidatureFormationId'].previousValue != null
                    && changes['candidatureFormationId'].previousValue !== changes['candidatureFormationId'].currentValue) ||
                (changes['candidatureFormationFc'] != null
                    && changes['candidatureFormationFc'].previousValue != null
                    && changes['candidatureFormationFc'].previousValue !== changes['candidatureFormationFc'].currentValue)
            )
            && !this.isReloading
            && this.ngInitDone) {
            this.isReloading = true;
            this.pieces = [];
            this.otherUploadedFiles = [];
            this.uploadedFiles = new KeyedCollection<any>();
            this.referents = [];
            this.piecesJointes = [];
            this.ngOnInit();
        }
    }

    ngOnInit() {
        if (this.loadReferentEvents != null) {
            this.loadReferentSubscription = this.loadReferentEvents.subscribe(() => {
                this.loadReferents();
            });
        }
        this.translate.onLangChange.subscribe(lang => this.currentLang = lang.lang);
        this.isSaving = true;
        // Get les paramétrages des pièces jointes
        this.parametrageService.query({page: CONSTANTS.PIECES}).subscribe(
            (res: Response) => {
                this.parametrage = this.parametrageService.parametresArrayToObject(res.json());
                this.maxSize = this.parametrage.MAX_SIZE.libelle;
            });
        if (this.candidatureFormation != null && this.candidatureFormation.id != null && this.candidatureFormation.formationId != null) {
            // get de la pièce recommandation
            let getPiece = this.pieceService.findByCode('LETTRE_RECOMMANDATION').subscribe((res: Response) => {
                this.lettreRecommandation = res;
            });

            // Get la liste des pièces jointes déjà uploadées
            this.pieceJointeService.query({candidatureFormationId: this.candidatureFormation.id}).subscribe((res: Response) => {
                this.piecesJointes = res.json();
                this.piecesJointes.forEach(pj => {
                    if (pj.pieceId === 1) {
                        this.otherUploadedFiles.push(pj);
                    } else {
                        this.uploadedFiles.Add(this.getPieceIndex(pj.pieceId, pj.referentId), pj);
                    }
                });

                // Get la liste des pièces pour la formation choisie
                let categorieFormationIdList: Number[] = [];
                categorieFormationIdList.push(this.candidatureFormation.categorieFormationId);
                this.pieceService.query({
                    categorieFormationIdList: categorieFormationIdList,
                    formationId: this.candidatureFormation.formationId,
                    isFormationContinue: this.candidatureFormation.fc,
                    etudiantId: this.candidatureFormation.userId
                }).subscribe((piecesResp: Response) => {
                    this.pieces = piecesResp.json();
                    this.isMissingPJ();
                    this.isSaving = false;
                    this.isReloading = false;
                });
                this.loadPJContent(); // Chargement de la visu des pj dans le BO
            });
            this.loadReferents();
        } else {
            this.isSaving = false;
            this.isReloading = false;
        }
        this.ngInitDone = true;
    }

    ngOnDestroy() {
        if (this.loadReferentSubscription != null) {
            this.loadReferentSubscription.unsubscribe();
        }
    }

    private loadReferents() {
        this.formationService.find(this.candidatureFormation.formationId).subscribe((res) => {
            if (res.nombreReferents > 0 && this.candidatureFormation.fc !== true) {
                this.referentService.query({candidatureFormationId: this.candidatureFormation.id}).subscribe(
                    (referents: Response) => {
                        this.referents = referents.json().sort((ref1, ref2) => {
                            if (ref1.id > ref2.id) {
                                return 1;
                            }
                            if (ref1.id < ref2.id) {
                                return -1;
                            }
                            return 0;
                        });
                        for (let i = this.referents.length; i < res.nombreReferents; i++) {
                            let newRef = new Referent();
                            if (res.id === CONSTANTS.ECHANGE_INTERNATIONAL_ID) {
                                if (i === 0) {
                                    newRef.typeReferent = CONSTANTS.CONTACT_PEDAGO;
                                }
                                if (i === 1) {
                                    newRef.typeReferent = CONSTANTS.CONTACT_ADMIN;
                                }
                            }
                            newRef.candidatureFormationId = this.candidatureFormation.id;
                            this.referents.push(newRef);
                        }
                        this.referents.forEach((referent, idx) => {
                            referent.obligatoire = idx < res.nombreReferentsObligatoires;
                        });
                        this.referentsChange.emit(this.referents);
                        if (this.isBO > 0 && this.referents != null) {
                            this.loadFormulaireRecommandationBO();
                        }
                        this.isSaving = false;
                        this.isReloading = false;
                    },
                    error => {
                        this.isSaving = false;
                        this.onError(error);
                    });
            }
        });
    }

// Envoyer le mail avec le formulaire de reco au référent
    sendMailToReferent(referent: Referent, idx) {
        this.isSaving = true;
        if (referent.nom == null || referent.nom.length < 1 || referent.prenom == null || referent.prenom.length < 1
            || referent.email == null || referent.email.length < 1 || referent.discipline == null || referent.discipline.length < 1
            || referent.etablissement == null || referent.etablissement.length < 1) {
            this.isSaving = false;
            return this.referents[idx].invalid = true;
        }
        referent.invalid = false;
        referent.key = 'true';
        this.referentService.update(referent, null).subscribe((res: Referent) => {
            this.referents[idx] = res;
            this.isSaving = false;
        }, error => {
            // CADENSCAD-192 Dédoublement des référents : ici pb si envoi mail provoque une erreur et que le referent
            // est enregistré ca provoque des doublons --> on recharge tous les referents
            this.referents = null;
            this.loadReferents();
            referent.key = null;
            this.onError(error);
        });
    }

    // Gestionnaire peut réinitialiser un formulaire de reco
    reinitMailToReferent(referent: Referent, idx) {
        this.isSaving = true;
        referent.key = null; // => suppr la key
        referent.formulaire = null;
        this.referentService.update(referent, null).subscribe((res: Referent) => {
                this.referents[idx] = res;
                this.isSaving = false;
            },
            error => {
                this.isSaving = false;
                this.onError(error);
            });
    }

    // Open a file in a new tab when click on it
    openFile(name: string) {
        // Get la liste des pièces jointes déjà uploadées
        this.pieceJointeService.openFile(name).subscribe((res) => {
                let fileUrl = URL.createObjectURL(res);
                window.open(fileUrl);
            },
            error => {
                this.isSaving = false;
                this.onError(error);
            });
    }

    // Open la popup d'aide
    openAide(pieceModal, piece) {
        this.aide = piece;
        this.modalService.open(pieceModal);
    }

    // When the file is uploaded
    onFileUploaded(event, idPiece, referentId) {
        let pj: PieceJointe = JSON.parse(event.xhr.response);
        let id = this.getPieceIndex(idPiece, referentId);
        if (this.uploadedFiles.Item(id) == null) {
            this.uploadedFiles.Add(id, {nom: pj.nom});
        } else {
            this.uploadedFiles.Item(id).nom = pj.nom;
        }
        if (this.isBO > 0) {
            this.loadFileContent(this.uploadedFiles.Item(id));
        }

        if (this.piecesJointes.find(p => this.getPieceIndex(p.pieceId, p.referentId) === id)) {
            this.piecesJointes.find(p => this.getPieceIndex(p.pieceId, p.referentId) === id).nom = pj.nom;
        } else {
            this.piecesJointes.push(pj);
            this.isMissingPJ();
        }
    }

    onOtherFileUploaded(event) {
        let pj: PieceJointe = JSON.parse(event.xhr.response);
        let notes = this.otherUploadedFiles[this.lastIdx].notes;
        this.otherUploadedFiles[this.lastIdx] = pj;
        this.otherUploadedFiles[this.lastIdx].notes = notes;
    }

    // Before the file is sent to the server for upload
    onBeforeUpload(event, id) {
        this.onBeforeUploadReferent(event, id, null);
    }

    // Before the file is sent to the server for upload
    onBeforeUploadReferent(event, id, referentId) {
        event.formData.append('pieceId', id);
        if (this.otherUploadedFiles != null && id === 1 && this.lastIdx != null
            && this.otherUploadedFiles[this.lastIdx] != null) {
            event.formData.append('pieceJointeId',
                this.otherUploadedFiles[this.lastIdx].id == null ? -1 : this.otherUploadedFiles[this.lastIdx].id);
        }
        this.alertId = id;
        event.formData.append('candidatureFormationId', this.candidatureFormation.id);
        if (referentId != null) {
            event.formData.append('referentId', referentId);
        }
    }

    // Before the file is sent to the server for upload
    // noinspection JSMethodCanBeStatic
    onBeforeSend(event) {
        event.xhr.setRequestHeader('X-XSRF-TOKEN', PiecesComponent.getCookie('XSRF-TOKEN'));
    }

    // Before the file is sent to the server for upload
    // noinspection JSMethodCanBeStatic
    onRemove(event, id) {
        event.formData.append('pieceId', id);
    }


    // Autres pièces justificatives
    addOtherPJ(modal, idx?: number) {
        this.modalRef = this.modalService.open(modal);
        if (!this.otherUploadedFiles) {
            this.otherUploadedFiles = [];
        }
        if (idx != null) {
            this.lastIdx = idx;
        } else {
            this.otherUploadedFiles.push({pieceId: 1});
            this.lastIdx = this.otherUploadedFiles.length - 1;
        }
    }


    saveOtherPJ(modal) {
        if (this.otherUploadedFiles[this.lastIdx].nom != null) {
            this.pieceJointeService.update(this.otherUploadedFiles[this.lastIdx]).subscribe((res) => {
                    this.otherUploadedFiles[this.lastIdx] = res;
                    this.modalRef.close();
                },
                error => {
                    this.isSaving = false;
                    this.onError(error);
                });
        }
    }

    closeOtherPJ() {
        if (this.otherUploadedFiles[this.lastIdx].id == null) {
            this.otherUploadedFiles.pop();
        }
        this.modalRef.close();
    }

    deleteOtherPJ() {
        this.pieceJointeService.delete(this.otherUploadedFiles[this.lastIdx].id).subscribe((res) => {
                this.otherUploadedFiles.splice(this.lastIdx, 1);
                this.modalRef.close();
            },
            error => {
                this.isSaving = false;
                this.onError(error);
            });
    }

    // Afficher le contenu des pièces jointes dans le Back Office dans la page web
    private loadPJContent() {
        if (this.isBO > 0) {
            this.uploadedFiles.Values().forEach(piece => {
                this.loadFileContent(piece);
            });
            this.otherUploadedFiles.forEach(piece => {
                this.loadFileContent(piece);
            });
        }
    }

    private loadFileContent(piece) {
        this.pieceJointeService.openFile(piece.nom).subscribe((res) => {
                this.pieceJointeService.initPDFOrImageFile(res, piece);
            },
            error => {
                this.isSaving = false;
                this.onError(error);
            });
    }

    private loadFormulaireRecommandationBO() {
        this.referents.forEach((referent: Referent) => {
            if (referent.id != null) {
                let getQuestions = this.questionService.query();
                let getReponses = this.reponseService.query({
                    referentId: referent.id
                });
                Observable.forkJoin([getQuestions, getReponses]).subscribe(results => {
                        let questions = results[0].json();
                        let reponses: Reponse[] = results[1] != null ? results[1].json() : [];

                        questions.forEach(question => {
                            question.referentId = referent.id;
                            let rep = reponses.find(r => question.id === r.question.id);
                            if (rep) {
                                question.reponse = rep.response;
                            }
                        });
                        referent.questions = questions.filter(question => question.reponse != null);
                        if ((this.radios == null || this.radios.length === 0) && referent.questions.length > 0) {
                            this.getRadios(referent.questions);
                        }
                    },
                    error => {
                        this.isSaving = false;
                        this.onError(error);
                    });
            }
        });
    }

    private getRadios(questions) {
        if (questions != null) {
            questions.forEach(question => {
                if (question.typeReponse === 'RADIO' && question.reponseComplement != null) {
                    let choix = question.reponseComplement.split('|');
                    let idx = this.radios.map(radio => radio.join('|')).indexOf(question.reponseComplement);
                    if (idx < 0) {
                        this.radios.push(choix);
                    }
                }
            });
        }
    }

    /**
     * Check if one of the PJ is mandatory and missing
     */
    private isMissingPJ() {
        if (this.pieces != null && this.pieces.length > 0) {
            if (this.piecesJointes == null || this.piecesJointes.length === 0) {
                this.missingPieces = true;
            } else {
                let piecesMandat = this.pieces.filter(p => p.obligatoire === true);
                let pjMandat = this.piecesJointes.filter(pj => piecesMandat.findIndex(p => p.id === pj.pieceId) > -1);
                this.missingPieces = piecesMandat.length > pjMandat.length;
            }
        } else {
            this.missingPieces = false;
        }
        this.missingPiecesChange.emit(this.missingPieces);
    }

    public calculTitreReferent(referent: Referent): String {
        let titre = '';
        let param;
        if (referent != null) {
            if (this.parametrage != null) {
                if (referent.typeReferent === CONSTANTS.CONTACT_PEDAGO) {
                    param = this.parametrage.PIECES_REFERENTS_PEDAGO;
                } else {
                    if (referent.typeReferent === CONSTANTS.CONTACT_ADMIN) {
                        param = this.parametrage.PIECES_REFERENTS_ADMIN;
                    } else {
                        param = this.parametrage.PIECES_REFERENTS;
                    }
                }
            }
        }
        if (param) {
            titre = this.currentLang === 'fr' ? param.libelle : param.libelleEn;
        }
        return titre;
    }

    // noinspection JSMethodCanBeStatic
    public getPieceIndex(pieceId, referentId): any {
        return PieceJointe.getPieceIndex(pieceId, referentId);
    }

    onError(response: Response) {
        JhiAlertComponent.onError(this.alertService, response);
    }

    onErrorMessage(message: any) {
        JhiAlertComponent.onErrorMessage(this.alertService, message, null);
    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/pieces/pieces.component.ts